<template>
  <v-container fluid class="pa-0">
    <!-- Header Section -->
    <v-app-bar flat color="white" class="border-bottom">
      <v-btn @click="beforeRoute" icon class="mr-3">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title class="text-h5 font-weight-bold primary--text">
        <v-icon class="mr-2" color="primary">mdi-package-variant</v-icon>
        Recepción de Compra #{{
          filLeft(data_receptions[0]?.entry_id?.toString() || "", 12, "0")
        }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="downloadPDF" color="primary" class="mr-3" :loading="loadingPDF">
        <v-icon left>mdi-printer</v-icon>
        Imprimir
      </v-btn>
      <v-chip
        :color="getStatusColor(data_receptions[0]?.last_status_name)"
        text-color="white"
        class="font-weight-bold"
      >
        {{ data_receptions[0]?.last_status_name }}
      </v-chip>
    </v-app-bar>

    <v-container v-if="!loading" class="pa-6">
      <!-- Reception Information Card -->
      <v-card class="mb-6 elevation-3" outlined>
        <v-card-title class="primary white--text">
          <v-icon class="mr-2" color="white">mdi-information</v-icon>
          Información General
        </v-card-title>
        <v-card-text class="pa-6">
          <v-row>
            <v-col cols="12" md="4">
              <v-list dense class="transparent">
                <v-list-item class="py-1">
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-file-document</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="py-0">
                    <v-list-item-title class="font-weight-bold"
                      >Orden #</v-list-item-title
                    >
                    <v-list-item-subtitle class="text-h7">

                      <v-hover v-slot="{ hover }">
                        <span
                          @click="showOrder(data_receptions[0]?.order_id, false)"
                          class="primary--text font-weight-normal text-truncate font-weight-semibold"
                          :style="{
                            color: hover ? 'red' : 'black',
                            cursor: hover ? 'pointer' : '',
                            'text-decoration': hover ? 'underline' : '',
                          }"
                        >
                          {{ filLeft(data_receptions[0]?.order_id?.toString(), 12, "0") }}</span
                        >
                      </v-hover>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                  <v-list-item class="py-1">
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-file-document</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="py-0">
                    <v-list-item-title class="font-weight-bold"
                      >Factura #</v-list-item-title
                    >
                    <v-list-item-subtitle class="text-h8">
                       <v-hover v-slot="{ hover }">
                          <span v-if="data_receptions[0]?.invoice_id!=null"
                            @click="showInvoice(data_receptions[0]?.invoice_id, true)"
                            class="primary--text font-weight-normal text-truncate font-weight-semibold"
                            :style="{
                              color: hover ? 'red' : 'black',
                              cursor: hover ? 'pointer' : '',
                              'text-decoration': hover ? 'underline' : '',
                            }"
                          >
                            <span class="red--text d-flex" >
                            </span>

                          {{ data_receptions[0]?.invoice_number?.toString() }}
                          </span>
                          <span v-else>PENDIENTE POR FACTURAR</span>
                        </v-hover>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="py-1">
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-file-document</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="py-0">
                    <v-list-item-title class="font-weight-bold"
                      >Asiento</v-list-item-title
                    >
                    <v-list-item-subtitle>
                        <v-hover v-slot="{ hover }">
                          <span
                            @click="show_entry()" black
                            class="primary--text font-weight-normal"
                            :style="{
                              color: hover ? 'red' : 'black',
                              cursor: hover ? 'pointer' : '',
                              'text-decoration': hover ? 'underline' : '',
                            }"
                          >
                            {{ data_receptions[0]?.diary_book_details.diary_book_code }}</span
                          >
                        </v-hover>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" md="4">
              <v-list dense class="transparent">
                <v-list-item class="py-1">
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-domain</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="py-0">
                    <v-list-item-title class="font-weight-bold"
                      >Proveedor</v-list-item-title
                    >
                    <v-list-item-subtitle>{{
                      data_receptions[0]?.entity_name
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                                <v-list-item class="py-1">
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-file-document</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="py-0">
                    <v-list-item-title class="font-weight-bold"
                      >Factura suplidor</v-list-item-title
                    >
                    <v-list-item-subtitle>{{
                      data_receptions[0]?.supplier_invoice_number || 'N/A'
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="py-1">
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-card-account-details</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="py-0">
                    <v-list-item-title class="font-weight-bold">RNC</v-list-item-title>
                    <v-list-item-subtitle>{{
                      data_receptions[0]?.rnc
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" md="4">
                <v-list dense class="transparent">
                               <v-list-item class="py-1">
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-map-marker</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="py-0">
                    <v-list-item-title class="font-weight-bold"
                      >Ubicación</v-list-item-title
                    >
                    <v-list-item-subtitle>{{
                      data_receptions[0]?.location_description_long
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="py-1">
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-calendar</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="py-0">
                    <v-list-item-title class="font-weight-bold"
                      >Fecha de Creación</v-list-item-title
                    >
                    <v-list-item-subtitle>{{
                      dateFormated(data_receptions[0]?.created_date)
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="py-1">
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="py-0">
                    <v-list-item-title class="font-weight-bold"
                      >Elaborado por</v-list-item-title
                    >
                    <v-list-item-subtitle>{{
                      data_receptions[0]?.user_fullname
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Items Table -->
      <v-card class="mb-6 elevation-3" outlined>
        <v-card-title class="success white--text">
          <v-icon class="mr-2" color="white">mdi-package-variant-closed</v-icon>
          Productos/Servicios
        </v-card-title>
        <v-card-text class="pa-0">
          <v-data-table
            :headers="headers"
            :items="data_receptions[0]?.order_item_entries || []"
            class="elevation-0"
            hide-default-footer
            :items-per-page="-1"
          >
            <template v-slot:[`item.item_name`]="{ item }">
              <div class="py-2">
                <div class="font-weight-bold">{{ item.item_name }}</div>
                <div class="text-caption grey--text">ID: {{ item.item_id }}</div>
              </div>
            </template>
            <template v-slot:[`item.quantity`]="{ item }">
              <v-chip small color="info" text-color="white">
                {{ item.quantity }}
              </v-chip>
            </template>
            <template v-slot:[`item.price`]="{ item }">
              <span class="font-weight-bold">{{ currencyFormat(item.price) }}</span>
            </template>
            <template v-slot:[`item.discount`]="{ item }">
              <span class="font-weight-bold">{{ currencyFormat(item.discount*100) }}%</span>
            </template>
            <template v-slot:[`item.total`]="{ item }">
              <span class="font-weight-bold text-success">{{
                currencyFormat(item.quantity * (item.price - (item.price*item.discount)))
              }}</span>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="justify-end pa-4 grey lighten-5">
          <div class="text-h5 font-weight-bold primary--text">
            TOTAL: {{ currencyFormat(total) }} {{ data_receptions[0]?.currency_code }}
          </div>
        </v-card-actions>
      </v-card>
      <!-- Comments Section -->
      <v-card class="elevation-3" outlined v-if="data_receptions[0]?.comment">
        <v-card-title class="info white--text">
          <v-icon class="mr-2" color="white">mdi-note-text</v-icon>
          Comentarios
        </v-card-title>
        <v-card-text class="pa-4">
          <div class="text-body-1">{{ data_receptions[0]?.comment }}</div>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- Loading State -->
    <v-container v-else class="text-center pa-12">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
      <div class="mt-4 text-h6 grey--text">Cargando información...</div>
    </v-container>
  </v-container>
</template>

<script>
import moment from "moment";

import momentTimezone from "moment-timezone";
export default {
  data: () => ({
    dialog: false,
    loading: false,
    loadingPDF: false,
    search: "",

    selectedAttached: "",
    loadingAttachment: false,
    dialogAttached: false,
    data_receptions: [],

    headers: [
      {
        text: "Producto/Servicio",
        align: "start",
        sortable: false,
        value: "item_name",
        width: "40%",
      },
      {
        text: "Unidad",
        align: "center",
        sortable: false,
        value: "unit_name",
        width: "15%",
      },
      {
        text: "Cantidad",
        value: "quantity",
        align: "center",
        width: "15%",
      },
      {
        text: "Precio Unitario",
        value: "price",
        align: "end",
        width: "15%",
      },
      {
        text: "Descuento",
        value: "discount",
        align: "end",
        width: "15%",
      },
      {
        text: "Total",
        value: "total",
        align: "end",
        width: "15%",
      },
    ],
  }),

  computed: {
    total() {
      if (!this.data_receptions[0] || !this.data_receptions[0].order_item_entries) {
        return 0;
      }
      let tot = 0;
      for (let item of this.data_receptions[0].order_item_entries) {
        tot = tot + (item.price-(item.price*item.discount)) * item.quantity;
      }
      return tot;
    },

    accountingEntries() {
      if (!this.data_receptions[0] || !this.data_receptions[0].order_item_entries) {
        return [];
      }
      let entries = [];
      for (let item of this.data_receptions[0].order_item_entries) {
        if (item.order_chart_of_accounts && item.order_chart_of_accounts.length > 0) {
          entries = entries.concat(item.order_chart_of_accounts);
        }
      }
      return entries;
    },
  },

  created() {
    this.getData();
  },
  methods: {
    dateFormated(date) {
      //const dates = moment(date).format('DD/MM/YYYY h:mm a');
      return momentTimezone(date).tz("America/Santo_Domingo").format("DD/MM/YYYY h:mm a");
    },

    async getData() {
      this.loading = true;
      this.order_id = this.$route.params.order_id;
      let id_receptions = this.$route.params.id;

      let filters = " AND entry_id=" + id_receptions;
      const responseRequest = await this.api_Post("shopping/search_entry_order", {
        order_id: this.order_id,
        filters: filters,
      });
      if (responseRequest.status == 200) {
        this.data_receptions = await responseRequest.json();
      } else {
        this.$toast.error("error al cargar la factura!");
      }

      this.loading = false;
    },
    getDate(item) {
      return moment(item).format("DD/MM/YYYY");
    },

    getStatusColor(status) {
      const statusColors = {
        Cerrada: "success",
        Abierta: "warning",
        Pendiente: "info",
        Cancelada: "error",
        "En Proceso": "primary",
      };
      return statusColors[status] || "grey";
    },

    async downloadPDF() {
      this.loadingPDF = true;
      try {
        let id_receptions = this.$route.params.id;
        let filters = " AND entry_id=" + id_receptions;

        const responseDataPdf = await this.api_Post("shopping/download_receptions", {
          order_id: this.order_id,
          filters: filters,
        });

        if (responseDataPdf.status === 200) {
          const blob = await responseDataPdf.blob();
          const pdfUrl = URL.createObjectURL(blob);

          // Abrir el PDF en una nueva pestaña
          window.open(pdfUrl, "_blank");
        } else {
          this.$toast.error("Error al generar el PDF de recepción!");
        }
      } catch (error) {
        console.error("Error downloading PDF:", error);
        this.$toast.error("Error al descargar el PDF!");
      } finally {
        this.loadingPDF = false;
      }
    },
    show_entry(){
        let route = this.$router.resolve({name: "ViewEntryDetail",params: { id: this.data_receptions[0]?.diary_book_details.diary_book_id }, });
        window.open(route.href);
      },
  },
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #e0e0e0 !important;
}

.v-card {
  transition: all 0.3s ease;
}

.v-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

.v-list-item {
  padding: 8px 16px;
}

.v-list-item-title {
  font-size: 14px;
  color: #424242;
}

.v-list-item-subtitle {
  font-size: 16px;
  color: #212121;
  font-weight: 500;
}

.v-data-table >>> .v-data-table__wrapper {
  border-radius: 0;
}

.v-data-table >>> tbody tr:hover {
  background-color: #f5f5f5 !important;
}

.v-card-title {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.text-success {
  color: #4caf50 !important;
}

.grey.lighten-5 {
  background-color: #fafafa !important;
}

@media (max-width: 768px) {
  .v-container {
    padding: 12px;
  }

  .v-card-text {
    padding: 16px;
  }

  .v-list-item-subtitle.text-h6 {
    font-size: 14px;
  }
}
</style>
